<template>
  <IndexForm :is-whitelabel="isWhitelabel">
    <BuyerRegistrationPageForm
      v-if="brpDetails"
      :action-status="actionStatus"
      :brp-details="brpDetails"
      @on-register="onSubmit"
    />
    <OpenRegistrationPageError
      v-if="!brpDetails"
      :applicant-type="'buyer'"
    />
  </IndexForm>
</template>

<script>

import messages from '../../locales';
import BuyerRegistrationPageForm from './BuyerRegistrationPageForm';
import OpenRegistrationPageError from '@/modules/auth/components/OpenRegistrationPage/OpenRegistrationPageError';
import IndexForm from '@/modules/auth/components/OpenRegistrationPage/IndexForm';
import { mapState, mapActions } from 'vuex';
import { getStatus } from '@/store/helpers';

export default {
  components: { BuyerRegistrationPageForm, OpenRegistrationPageError, IndexForm },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    brpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
    brpId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendBRPRequest')
    })
  },
  methods: {
    ...mapActions('auth', ['sendBRPRequest']),
    onSubmit(requestData) {
      this.sendBRPRequest({ brpId: this.brpId, requestData });
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style scoped>

</style>